"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _lodash = require("lodash");

var React = _interopRequireWildcard(require("react"));

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var withDebounce = function withDebounce(Component) {
  var WithDebounce = function WithDebounce(_ref) {
    var _ref$debouncedProps = _ref.debouncedProps,
        debouncedProps = _ref$debouncedProps === void 0 ? [] : _ref$debouncedProps,
        _ref$debouncedTimer = _ref.debouncedTimer,
        debouncedTimer = _ref$debouncedTimer === void 0 ? 1000 : _ref$debouncedTimer,
        rest = (0, _objectWithoutProperties2["default"])(_ref, ["debouncedProps", "debouncedTimer"]);
    var generateState = React.useMemo(function () {
      return debouncedProps.reduce(function (acc, item) {
        return _objectSpread(_objectSpread({}, acc), {}, (0, _defineProperty2["default"])({}, item, rest[item]));
      }, {});
    }, [debouncedProps, rest]);

    var _React$useState = React.useState(generateState),
        _React$useState2 = (0, _slicedToArray2["default"])(_React$useState, 2),
        propState = _React$useState2[0],
        setState = _React$useState2[1];

    var debouncedSetState = (0, _lodash.debounce)(setState, debouncedTimer);
    React.useEffect(function () {
      if (!(0, _lodash.isEqual)(propState, generateState)) {
        if (debouncedProps.length) {
          debouncedSetState(generateState);
        } else {
          setState(generateState);
        }
      }

      return function () {
        debouncedSetState.cancel();
      };
    }, [debouncedSetState, debouncedProps, generateState, propState]);
    return /*#__PURE__*/React.createElement(Component, (0, _extends2["default"])({}, (0, _lodash.omit)(rest, debouncedProps), propState));
  };

  return WithDebounce;
};

exports["default"] = withDebounce;
//# sourceMappingURL=index.js.map